import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/fraud/fraud.module').then(m => m.FraudModule)
  },
];
